import { useTranslate } from '@tolgee/react';
import { Tabs } from 'antd';
import Reputation from '../Reputation';
import QaReply from './QaReply';
import styled from '@emotion/styled';

function Mercado() {
  const { t } = useTranslate();

  return (
    <Container>
      <Tabs>
        <Tabs.TabPane key="qa" tab={t('Q&A回复')}>
          <QaReply />
        </Tabs.TabPane>
        <Tabs.TabPane key="reputation" tab={t('店铺声誉')}>
          <Reputation />
        </Tabs.TabPane>
      </Tabs>
    </Container>
  );
}

const Container = styled.div`
  height: 100%;
  margin-top: 16px;
  > .ant-tabs {
    height: 100%;
    .ant-tabs-nav {
      margin-bottom: 0;
      padding: 0 24px;
      background: var(--fett-bg-panel);
    }
    .ant-tabs-content-holder {
      flex: 1 0 0;
      .ant-tabs-content {
        height: 100%;
      }
    }
  }
`;

export default Mercado;
